import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/copy-from-priority/paket-tryout";

export default {
  getList(search = "") {
    return Client.get(resource, {
      params: { search },
    });
  },
  copy(paketTryoutId) {
    return Client.post(resource, {
      paket_tryout_id: paketTryoutId,
    });
  },
};
